import { Helmet } from 'react-helmet';
import {
    Avatar,
    Box, Button, Card, CardContent,
    Container, Divider,
    Grid, Tab, Tabs, Collapse, Typography, tableCellClasses, ClickAwayListener, TextField, FormGroup, FormControlLabel, Checkbox, Paper, Grow, Popper, MenuList
} from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import cssVariables from "../../../../theme/cssVariables";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emty from "../../../../assets/images/emty.png";
import { ReactComponent as BtnFilter } from "../../../../assets/images/btn-filter.svg";
import { useParams } from "react-router-dom";
import { ReactComponent as DraftIcon } from "../../../../assets/images/iconStatus/draft.svg";
import { ReactComponent as ApprovedIcon } from "../../../../assets/images/iconStatus/approved.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/edit.svg";
import { ReactComponent as StartIcon } from "../../../../assets/images/start.svg";
import { ReactComponent as SaveIcon } from "../../../../assets/images/save.svg";
import { ReactComponent as CancelIcon } from "../../../../assets/images/cancel.svg";
import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar-month.svg";
import { ReactComponent as InfoIcon } from "../../../../assets/icons/info.svg";
import { ReactComponent as TeamIcon } from "../../../../assets/images/people.svg";
import { ReactComponent as InnovationIcon } from "../../../../assets/images/position-icon.svg";
import { ReactComponent as ErrorIcon } from "../../../../assets/images/circle-fill-error.svg";
import { ReactComponent as Signoff } from "../../../../assets/images/signoff.svg";
import { ReactComponent as Megaphone } from "../../../../assets/images/megaphone.svg";
import DialogSendToApprove from "../../../../components/kpi/DialogSendToApprove";
import { tabsClasses } from '@mui/material/Tabs';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import Congrtulations from "../../../../components/kpi/Congrtulations";
import EvaluationRatio from "./EvaluationRatio";
import TotalAchievements from "../../../../components/baseComponent/TotalAchievements";
import RatingSummary from "./RatingSummary";
import Stack from '@mui/material/Stack';
import file from "../../../../assets/images/home/file.svg";
import icon360 from "../../../../assets/icons/icon360.svg";
import signatures from "../../../../assets/images/home/signatures.svg";
import { ReactComponent as ChevronDown } from "../../../../assets/images/home/chevron-down.svg";
import { ReactComponent as ChevronUp } from "../../../../assets/images/home/chevron-up.svg";
import { ReactComponent as Checks } from "../../../../assets/icons/checks.svg";
import * as Util from "../../../../services/global.service";
import blockSignatures from "../../../../assets/images/signatures.svg";
import CommentTab from "./CommentTab";
import evaluateService from "../../../../services/evaluate.service";
import ListData from "./ListData"
import MoreInfo from "../../../../components/kpi/MoreInfo";
import { ReactComponent as DateIcon } from "../../../../assets/images/date-work.svg";
import { object } from 'prop-types';

const styles = {
    path: {
        color: "#68717A",
    },
    paDatasEvaluation: {
        marginTop: "-12px",
        marginLeft: "19px",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    lastToolBar: {
        marginTop: "0px",
    },
    blueBadge: {
        background: "rgba(93, 161, 150, 0.15)",
        padding: "5px 12px",
        color: "#5DA196",
        border: "1px solid #5DA196",
        borderRadius: "4px"
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    colorText: {
        color: "#404349",
        fontWeight: "400",
        paddingLeft: "10px"
    },
    box: {
        width: "calc(50% - 30px)",
        "flex-direction": "row",
        margin: "15px 15px",
    },
    content: {
        background: "#FFFFFF",
        boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
        padding: "17px 22px",
        height: "100%",
    },
    emty: {
        display: "flex",
        "flex-flow": "column wrap",
        backgroundColor: "#fff",
        height: "220px",
        boxShadow: "0px 0px 5px rgb(0 0 0 / 10%)",
        borderRadius: "10px",
        "justify-content": "center",
        "align-items": "center",
        marginBottom: "30px"
    },
    twoContent: {
        display: "flex",
        "justify-content": "center",
        "flex-direction": "row",
        "align-items": "center",
    },
    boxTwoContent: {
        display: "flex",
        "justify-content": "space-between",
        "flex-direction": "row",
        "align-items": "center",
    },
    paperContainer: {
        backgroundImage: `url(${blockSignatures})`,
        width: "100%",
        minHeight: 160,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        borderRadius: "10px",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "550px",
    },
};

const Evaluation360 = () => {
    const _ = require('lodash');
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    let { serial, page } = useParams();
    const [value, setValue] = React.useState('overall');
    const [instruction, setInstruction] = React.useState('');
    const [valueSerial, setValueSerial] = React.useState('');
    // const [valueType, setValueType] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [openMenu, setOpenMenu] = React.useState(false);
    const [openMenus, setOpenMenus] = React.useState(false);
    const [openMenusCompetency, setOpenMenusCompetency] = React.useState(false);
    const anchorRef = React.useRef(null);
    const anchorRefCompetency = React.useRef(null);
    const [workloadFormSelect, setWorkloadForm] = React.useState([
        {
            description: "Performance Evaluation of 2020-2021",
            serial: "1",
        },
        {
            description: "Performance Evaluation of 2019-2020",
            serial: "2",
        }
    ]);
    const [Datas, setData] = React.useState([]);
    const [mainData, setMainData] = React.useState([]);
    const [dataEvaluate, setDataEvaluate] = React.useState([]);
    // redux state
    const [checkeNextAction, setCheckeNextAction] = React.useState({});
    const [isPromotionChecked, setPromotionChecked] = React.useState(false);
    const [statusEdit, setSstatusEdit] = React.useState(false);
    const [statusSend, setSstatusSend] = React.useState(false);
    const [hideEvaluation, setHideEvaluation] = React.useState(false);
    const [update, setUpdate] = React.useState(false);
    const [isSuccessSaveDialogOpen, openSuccessSaveDialog] = React.useState(false);
    const [isSuccessRejectDialogOpen, openSuccessRejectDialog] = React.useState(false);
    const [isSuccessSignoffDialogOpen, openSuccessSignoffDialogOpen] = React.useState(false);
    const [isConfirmCancelDialogOpen, openConfirmCancelDialog] = React.useState(false);
    const [isSuccessCancelDialogOpen, openSuccessCancelDialog] = React.useState(false);
    const [dataFormSave, setdataFormSave] = React.useState({
        // form_evaluate: serial,
        // editor: "",
        // goal: [],
        // competency: [],
        // comment: []
    });
    const [actSave, setActSave] = React.useState(false);
    const [submitError, setSubmitError] = React.useState(false);
    const [showTypeError, setShowTypeError] = React.useState({});
    const [employeeSignatures, setEmployeeSignatures] = React.useState("");
    const [commentPromotion, setCommentPromotion] = React.useState("");
    const [evaluatorSignatures, setEvaluatorSignatures] = React.useState("");
    const language = localStorage.getItem("lang");
    const [editPromotion, setEditPromotion] = React.useState(false);
    const [checkDatas, setCheckDatas] = React.useState(false);
    const [color, setColor] = React.useState([]);
    const [DatasEvaluation, setDataEvaluation] = React.useState({});
    const [checkFilter, setCheckFilter] = React.useState({
        goalsSuccess: true,
        goalsError: true,
        goalsNoGap: true,
    });
    const [checkFilterCompetency, setCheckFilterCompetency] = React.useState({
        goalsSuccess: true,
        goalsError: true,
        goalsNoGap: true,
    });

    let callBack = async (data, type, ref_template_id) => {
        if (Object.keys(dataFormSave).length > 0) {
            dataFormSave.editor = dataEvaluate?.editor === "self" ? "self" : dataEvaluate?.editor === "evaluator" ? "evaluator" : ""
            if (type === "evaluate_comment") {
                dataFormSave[type] = formatData(data?.evaluator, [])
            } else {
                if (dataFormSave[type] !== undefined && dataFormSave[type].length > 0) {
                    for (let idex = 0; idex <= data.length - 1; idex++) {
                        let check = dataFormSave[type].filter((rs) => rs?.serial === data[idex]?.serial)
                        if (check.length > 0) {
                            for (let index = 0; index <= dataFormSave[type].length - 1; index++) {
                                if (dataFormSave[type][index]?.serial === data[idex]?.serial) {
                                    dataFormSave[type][index] = data[idex]
                                }
                            }
                        } else {
                            dataFormSave[type].push(data[idex])
                        }
                    }
                } else {
                    dataFormSave[type] = data
                }
            }
            if (update === false) {
                setUpdate(true)
            }
        } else {
            let setDataForm = {
                "form_evaluate": serial,
                "editor": dataEvaluate?.editor === "self" ? "self" : dataEvaluate?.editor === "evaluator" ? "evaluator" : "",
                "goal": [
                ],
                "competency": [
                ],
                "evaluate_comment": [
                ]
            }
            if (type === "evaluate_comment") {
                setDataForm[type] = formatData(data?.evaluator, [])
            } else {
                setDataForm[type] = data
            }
            await setdataFormSave(setDataForm)
        }
    }

    const onHideEvaluationChange = () => {
        setHideEvaluation(!hideEvaluation);
    };
    const onPromotionChange = () => {
        if (statusEdit && checkeNextAction?.options?.promote?.can_edit === true) {
            setPromotionChecked(!isPromotionChecked)
        }
    }

    const checkDataSave = () => {
        let sumData = 0
        if (Util.formatData(dataFormSave?.goal, false) !== false && dataFormSave?.goal.length > 0) {
            sumData = sumData + 1
        }
        if (Util.formatData(dataFormSave?.competency, false) !== false && dataFormSave?.competency.length > 0) {
            sumData = sumData + 1
        }
        if (Util.formatData(dataFormSave?.evaluate_comment, false) !== false && Object.keys(dataFormSave?.evaluate_comment).length > 0) {
            sumData = sumData + 1
        }
        if (Util.formatData(dataFormSave?.custom, false) !== false && dataFormSave?.custom.length > 0) {
            sumData = sumData + 1
        }
        if (editPromotion) {
            sumData = sumData + 1
        }
        if (sumData > 0) {
            return false;
        } else {
            return true;
        }
    };
    useEffect(() => {
        if (statusEdit) {
            if (isPromotionChecked === false) {
                setEmployeeSignatures("")
                setCommentPromotion("")
            }
            if (editPromotion === false) {
                setEditPromotion(true)
            }
        }
    }, [isPromotionChecked, employeeSignatures, commentPromotion]);

    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
            fontSize: "14px"
        },
    }));
    const tabs = _.groupBy(DatasEvaluation.rubrics, function (loRow) {
        return loRow.rubricCat;
    })

    useEffect(() => {
        getDetail()
        // dataRating()
    }, []);


    const getDetail = () => {
        evaluateService.getEvaliation360Detail(serial).then(
            (rs) => {
                setMainData(rs?.data?.evaluate_component)
                setData(rs?.data?.evaluate_component)
                setInstruction(Util.formatData(rs?.data?.instruction, ""))
                setDataEvaluate(rs?.data)
                showError(rs?.data.evaluate_component, rs?.data,)
                let getdata = Util.formatData(rs?.data?.evaluate_component, []).filter((rs) => Util.formatData(rs?.list_item, []).length > 0 && rs?.type !== "comment")
                if (getdata.length > 0) {
                    let getColor = Util.formatData(getdata[0]?.list_item, []).map((n) => Util.formatData(n?.options?.color, n?.color))
                    setColor(getColor)
                }
            }).catch(() => {

            })
    }
    useEffect(() => {
        if (isSuccessSaveDialogOpen === false && actSave === true) {
            getDetail()
            // dataRating()
        }
    }, [isSuccessSaveDialogOpen]);
    useEffect(() => {
        setDateWork()
    }, [dataEvaluate]);
    let closeSuccessSaveDialog = async () => {
        await setActSave(true)
        setSstatusEdit(false)
        openSuccessSaveDialog(false)
        setUpdate(false)
        setdataFormSave({
            // form_evaluate: serial,
            // editor: "",
            // goal: [],
            // competency: [],
            // comment: []
        })
        getDetail()
    }

    let closeRejectSuccess = () => {
        openSuccessRejectDialog(false)
        getDetail()
    }

    let showError = (data, allData) => {
        if (Util.formatData(data, false) !== false && data.length > 0) {
            let checkError = false
            let typeError = {}
            for (let index = 0; index <= data.length - 1; index++) {
                if (data[index]?.type === "comment") {
                    if (allData?.editor === "evaluator") {
                        if (typeError.comment !== true && Util.formatData(data[index].list_item, false) !== false && data[index].list_item.length > 0) {
                            for (let id = 0; id <= data[index].list_item.length - 1; id++) {
                                if (typeError.comment !== true && data[index].list_item[id]?.is_required === true) {
                                    if (Util.formatData(data[index].list_item[id]?.comment, false) !== false && data[index].list_item[id]?.comment.length > 0) {
                                    } else {
                                        typeError.comment = true
                                        checkError = true
                                    }
                                }
                            }
                        }
                    }
                } else {
                    if (typeError.overall !== true && Util.formatData(data[index]?.list_item, false) !== false && data[index]?.list_item.length > 0) {
                        for (let id = 0; id <= data[index].list_item.length - 1; id++) {
                            if (typeError.overall !== true && data[index]?.type === "goal" && Util.formatData(data[index].list_item[id]?.goal_items, false) !== false && data[index].list_item[id]?.goal_items.length > 0) {
                                for (let order = 0; order <= data[index].list_item[id].goal_items.length - 1; order++) {
                                    if (typeError.overall !== true && allData?.editor === "self") {
                                        if (Util.formatData(data[index].list_item[id]?.goal_items[order]?.evaluate_rating?.self?.rating?.serial, false) === false) {
                                            typeError.overall = true
                                            checkError = true
                                        }
                                        if (data[index]?.require_employee_comment === true) {
                                            if (Util.formatData(data[index].list_item[id]?.goal_items[order]?.evaluate_rating?.self?.comment, false) === false) {
                                                typeError.overall = true
                                                checkError = true
                                            }
                                        }
                                    } else if (typeError.overall !== true && allData?.editor === "evaluator") {
                                        if (Util.formatData(data[index].list_item[id]?.goal_items[order]?.evaluate_rating?.evaluator?.rating?.serial, false) === false) {
                                            typeError.overall = true
                                            checkError = true
                                        }
                                        if (data[index]?.require_evaluator_comment === true) {
                                            if (Util.formatData(data[index].list_item[id]?.goal_items[order]?.evaluate_rating?.evaluator?.comment, false) === false) {
                                                typeError.overall = true
                                                checkError = true
                                            }
                                        }
                                    }
                                }
                            } else if (typeError.overall !== true && data[index]?.type === "competency" && Util.formatData(data[index].list_item[id]?.competency_items, false) !== false && data[index].list_item[id]?.competency_items.length > 0) {
                                for (let order = 0; order <= data[index].list_item[id].competency_items.length - 1; order++) {
                                    if (typeError.overall !== true && allData?.editor === "self") {
                                        if (Util.formatData(data[index].list_item[id]?.competency_items[order]?.evaluate_rating?.self?.rating?.value, false) === false) {
                                            typeError.overall = true
                                            checkError = true
                                        }
                                        if (data[index]?.require_employee_comment === true) {
                                            if (Util.formatData(data[index].list_item[id]?.competency_items[order]?.evaluate_rating?.self?.comment, false) === false) {
                                                typeError.overall = true
                                                checkError = true
                                            }
                                        }
                                    } else if (typeError.overall !== true && allData?.editor === "evaluator") {
                                        if (Util.formatData(data[index].list_item[id]?.competency_items[order]?.evaluate_rating?.evaluator?.rating?.value, false) === false) {
                                            typeError.overall = true
                                            checkError = true
                                        }
                                        if (data[index]?.require_evaluator_comment === true) {
                                            if (Util.formatData(data[index].list_item[id]?.competency_items[order]?.evaluate_rating?.evaluator?.comment, false) === false) {
                                                typeError.overall = true
                                                checkError = true
                                            }
                                        }
                                    }
                                }
                            } else if (typeError.overall !== true && data[index]?.type === "custom" && Util.formatData(data[index].list_item[id]?.custom_template_item, false) !== false && data[index].list_item[id]?.custom_template_item.length > 0) {
                                for (let order = 0; order <= data[index].list_item[id].custom_template_item.length - 1; order++) {
                                    if (typeError.overall !== true && allData?.editor === "self") {
                                        if (Util.formatData(data[index].list_item[id]?.custom_template_item[order]?.evaluate_rating?.self?.rating?.value, false) === false) {
                                            typeError.overall = true
                                            checkError = true
                                        }
                                        if (data[index]?.require_employee_comment === true) {
                                            if (Util.formatData(data[index].list_item[id]?.custom_template_item[order]?.evaluate_rating?.self?.comment, false) === false) {
                                                typeError.overall = true
                                                checkError = true
                                            }
                                        }
                                    } else if (typeError.overall !== true && allData?.editor === "evaluator") {
                                        if (Util.formatData(data[index].list_item[id]?.custom_template_item[order]?.evaluate_rating?.evaluator?.rating?.value, false) === false) {
                                            typeError.overall = true
                                            checkError = true
                                        }
                                        if (data[index]?.require_evaluator_comment === true) {
                                            if (Util.formatData(data[index].list_item[id]?.custom_template_item[order]?.evaluate_rating?.evaluator?.comment, false) === false) {
                                                typeError.overall = true
                                                checkError = true
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            setShowTypeError(typeError)
            setSubmitError(checkError)
        }
    }

    useEffect(() => {
        let maybeHandler = (event) => {
            if (event.target.closest(".tooltip") === null) {
                setOpen(false)
                setValueSerial("")
                // setValueType("")
            }
        };

        document.addEventListener("click", maybeHandler);

        return () => {
            document.removeEventListener("click", maybeHandler);
        };
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const useStyles = makeStyles({
        iconContainer: {
            width: 48,
            height: 48,
            borderRadius: 5,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        root: {
            'border-width': 0,
            'padding-left': 0,
            [`&.${tableCellClasses.body}`]: {
                'border-width': 0,
                'padding-left': 0,
            }
        },
        tab: {
            fontSize: "16px !important",
            fontWeight: "400 !important",
            '&.Mui-selected': {
                color: cssVariables.color.primary + " !important"
            },
            '&.MuiTab-root': {
                "text-transform": "none"
            }
        },
        profileContainer: {
            width: 70,
            height: 70,
            borderRadius: "50%",
            marginTop: 3,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        containerAchievements: {
            background: "#FAFAFA",
            border: "1px solid #DADADA",
            borderRadius: "4px",
            maxWidth: "320px",
            width: "100%"
        },
        statusBadge: {
            maxWidth: "130px",
            borderRadius: "5px",
            padding: "5px 12px",
            margin: "0",
            background: ""
        },
        processBgYellow: {
            background: "#EFB76D26",
        },
        processTextYellow: {
            color: "#EFB76D",
        },
        processBgOrange: {
            background: "#F2802626",
        },
        processTextOrange: {
            color: "#F28026",
        },
        processBgGreen: {
            background: "#5DA19626",
        },
        processTextGreen: {
            color: "#5DA196",
        },
        processBgRed: {
            background: "#CC605826",
        },
        processTextRed: {
            color: "#CC6058",
        },
        processBgGrary: {
            background: "#82828226",
        },
        processTextGrary: {
            color: "#828282",
        },
        fillBlack: {
            '& > path': {
                fill: '#404349'
            },
            '& g > path': {
                fill: '#404349'
            },
        },
        btnDisabled: {
            '& .Mui-disabled': {
                color: "#FFFFFF !important",
                backgroundColor: "#BABABA !important",
                border: "none !important",
                '& svg > path': {
                    fill: '#FFFFFF !important'
                },
                '& svg > g > path': {
                    fill: '#FFFFFF !important'
                },
            }
        },
        btnNotDisabled: {
            paddingRight: "30px"
        }
    })
    const classes = useStyles();
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const onStart = (serial) => {
        evaluateService.requestEvaluationStart({
            evaluate_id: serial,
        }).then(
            (response) => {
                getDetail()
            },
        ).catch(() => {
            // handleOpenFailedMessageDialog()
        })
    }
    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }
    const dateFormat = (data) => {
        if (data !== undefined && data !== null && data !== "") {
            const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
            const dateTH = date.toLocaleDateString(i18n.language === "th-TH" ? "th-TH" : "en-GB", {
                year: '2-digit',
                month: 'short',
            })
            return dateTH
        }
    }
    const dateDayFormat = (data) => {
        if (data !== undefined && data !== null && data !== "") {
            const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
            const dateTH = date.toLocaleDateString(i18n.language === "th-TH" ? "th-TH" : "en-GB", {
                year: '2-digit',
                month: 'short',
                day: 'numeric',
            })
            return dateTH
        }
    }
    const onScroll = (evt) => {
        if (evt !== undefined && evt !== null) {
            if (openMenu) {
                setOpenMenu(false)
            }
            if (openMenus) {
                setOpenMenus(false)
            }
            if (openMenusCompetency) {
                setOpenMenusCompetency(false)
            }
        }
    }
    const onEdit = () => {
        setSstatusEdit(true)
        // setStatusValidate(false)
    }
    const onCancel = () => {
        handleConfirmCancelDialog(true)
    }
    const handleConfirmCancelDialog = (val) => {
        openConfirmCancelDialog(val)
    };
    const onSave = () => {
        let dataForms = JSON.parse(JSON.stringify(dataFormSave))
        if (Object.keys(dataForms).length < 1) {
            dataForms = {
                form_evaluate: serial,
                editor: "",
                goal: [],
                competency: [],
                evaluate_comment: [],
            }
        }
        dataForms.editor = dataEvaluate.editor === "self" ? "self" : dataEvaluate.editor === "evaluator" ? "evaluator" : ""
        dataForms.editor_ref_id = Util.formatData(dataEvaluate.editor_ref_id, "")
        dataForms.editor_type = Util.formatData(dataEvaluate.editor_type, "")
        evaluateService.saveEvaliationDetail360(dataForms).then((rs) => {
            openSuccessSaveDialog(true)
        }).catch((err) => { })
        if (statusSend === false) {
            setSstatusSend(true)
        }
    }
    const handleConfirmCancelList = () => {
        setUpdate(false)
        setdataFormSave({
            // form_evaluate: serial,
            // editor: "",
            // goal: [],
            // competency: [],
            // comment: []
        })
        handleConfirmCancelDialog(false)
        openSuccessCancelDialog(true)
        setSstatusEdit(false)
        getDetail()
        // setCheckAdd(!checkAdd)
        // if (statusSave) {
        // setStatusValidate(true)
        // }
    };
    const onClickSignoff = () => {
        evaluateService.submitForm({
            evaluate_id: serial,
        }).then(
            (response) => {
                openSuccessSignoffDialogOpen(true)
            },
        ).catch(() => {
        })
    };
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        onClickSignoff()
    };
    const handleCancel = () => {
        if (statusSend === false) {
            setSstatusSend(true)
        }
        setDiscardDialog(true)
    }
    const handleSignoffDialog = (value) => {
        openSuccessSignoffDialogOpen(value)
        getDetail()
    }
    const [openMoreInfo, setOpenMoreInfo] = React.useState(false);
    const onOpenMoreInfo = () => {
        setOpenMoreInfo(true)
    }
    const onCloseMoreInfo = () => {
        setOpenMoreInfo(false)
    }
    const [datePosition, setDatePosition] = React.useState("");
    const [dateEmpoloyee, setDateEmpoloyee] = React.useState("");
    const setDateWork = () => {
        if (Util.formatData(dataEvaluate?.candidate?.pos_exp, false) !== false && Util.formatData(dataEvaluate?.candidate?.pos_exp, false) !== false) {
            let dataPositionDate = dataEvaluate?.candidate?.pos_exp
            let dataEmpolyeeDate = dataEvaluate?.candidate?.emp_exp
            if (language === "en-US") {
                dataPositionDate = dataPositionDate.replace('y', 'y ')
                dataPositionDate = dataPositionDate.replace('m', 'm ')
                // dataPositionDate = dataPositionDate.replace('d', 'd ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('y', 'y ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('m', 'm ')
                // dataEmpolyeeDate = dataEmpolyeeDate.replace('d', 'd ')
                setDatePosition(dataPositionDate)
                setDateEmpoloyee(dataEmpolyeeDate)
            } else {
                dataPositionDate = dataPositionDate.replace('y', ' ปี ')
                dataPositionDate = dataPositionDate.replace('m', ' เดือน ')
                dataPositionDate = dataPositionDate.replace('d', ' วัน')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('y', ' ปี ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('m', ' เดือน ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('d', ' วัน')
                setDatePosition(dataPositionDate)
                setDateEmpoloyee(dataEmpolyeeDate)
            }

        }
    }
    return (
        <Box onScroll={onScroll} className="asd" style={{ "max-height": "100%", "overflow-y": "auto" }}>
            <Box id="back-to-top-anchor"> </Box>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => page === 1 || page === "1" ? clickLink('/kpi/inbox') : page === 2 || page === "2" ? clickLink('/kpi/my360evaluation') : page === 3 || page === "3" ? clickLink('/kpi/360evaluation-manager') : null}>{page === 1 || page === "1" ? t("label.inbox") : page === 2 || page === "2" ? t("label.manage360") : page === 3 || page === "3" ? t("label.manage360") : null}</span> / <span style={styles.end} >{dataEvaluate?.form !== undefined && dataEvaluate?.form !== null ? dataEvaluate?.form?.name : "-"}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid container item >
                            <Grid item md={12} xs={12}>
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <Typography variant="h2" fontWeight={600} color="#404349" fontSize={30} lineHeight={1.495}>
                                        {
                                            dataEvaluate?.form?.name
                                        }
                                    </Typography>
                                    <Box sx={{ flex: 2 }}></Box>
                                    {
                                        !statusEdit ?
                                            dataEvaluate?.editor_status !== "approved" ?
                                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                    <>
                                                        {/* <Box class={`${classes.btnNotDisabled}`}> */}
                                                        <Box class={dataEvaluate?.button?.can_edit !== true ? `${classes.btnDisabled} ${classes.btnNotDisabled}` : `${classes.btnNotDisabled}`}>
                                                            <Button onClick={onEdit} startIcon={<EditIcon />} sx={{ height: "45px", textTransform: "none", fontSize: "16px", borderColor: "#5DA196" }} variant="outlined" >{t("label.edit")}</Button>
                                                        </Box>
                                                        <DialogSendToApprove serial={serial} is360={true} submitError={submitError} can_submit={dataEvaluate?.button?.can_edit} loadDataDetail={getDetail} setActSave={null} nameButton={t('label.sendToApprove')} />
                                                    </>
                                                </Box>
                                                :
                                                null
                                            :
                                            dataEvaluate?.editor_status !== "approved" ?
                                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                    <Box sx={{ paddingRight: "30px" }}>
                                                        <Button onClick={onCancel} startIcon={<CancelIcon />} sx={{ height: "45px", textTransform: "none", fontSize: "16px" }} variant="contained" color="red">{t("label.cancel")}</Button>
                                                    </Box>
                                                    <Box className={checkDataSave() === true ? `${classes.btnDisabled}` : ""}>
                                                        <Button onClick={onSave} startIcon={<SaveIcon />} disabled={checkDataSave()} sx={{ height: "45px", textTransform: "none", fontSize: "16px" }} variant="contained">{t("label.save")}</Button>
                                                    </Box>
                                                </Box>
                                                :
                                                null
                                    }
                                </Box>
                                {submitError && actSave ?
                                    <Box pt="30px">
                                        <Box sx={{ background: "rgba(86, 125, 244, 0.1)", border: "1px solid #567DF4", borderRadius: "5px", display: "flex", alignItems: "center", padding: "20px" }}>
                                            <ErrorIcon></ErrorIcon>
                                            <Typography fontSize={18} lineHeight="19.8px" color="#567DF4" pl="10px">
                                                {t('evaluation.warning')}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    : null}
                                <Grid container item pb={2} pt={2}>
                                    <Grid item xs sm md lg>
                                        <Card sx={{ height: 1, "box-shadow": "0px 0px 5px rgba(0, 0, 0, 0.1)", "border-radius": "10px" }}>
                                            <CardContent sx={{ padding: "20px" }}>
                                                <Grid container mb="20px">
                                                    <Grid item lg={12} xs={12} display="flex" alignItems="center">
                                                        <Typography variant="h3" fontWeight={600} color="#404349">
                                                            {
                                                                t('evaluation.evaluationInformation')
                                                            }
                                                        </Typography>
                                                    </Grid>
                                                    <Grid container mt={2} display="flex" alignItems="center">
                                                        <Grid item display="flex" alignItems="center" mr="10px">
                                                            <CalendarIcon class={`${classes.fillBlack}`}></CalendarIcon>
                                                        </Grid>
                                                        <Grid item xs="auto" sm="auto" md="auto" mr={11}>
                                                            <Box >
                                                                <Typography fontSize={18} lineHeight={1.1} color="#404349">
                                                                    {t('evaluation.evaluationCycle')}: {dateFormat(dataEvaluate?.form?.start_date)}-{dateFormat(dataEvaluate?.form?.end_date)}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container mt={2} display="flex" alignItems="center">
                                                        <Grid item display="flex" alignItems="center" mr="10px">
                                                            <CalendarIcon class={`${classes.fillBlack}`} sx={{ color: dataEvaluate?.is_late ? "#CC6058" : "#404349" }}></CalendarIcon>
                                                        </Grid>
                                                        <Grid item xs="auto" sm="auto" md="auto" mr={11}>
                                                            <Box >
                                                                <Typography fontSize={18} lineHeight={1.1} color={dataEvaluate?.is_late ? "#CC6058" : "#404349"}>
                                                                    {t('evaluation.dueDate')}: {dateDayFormat(dataEvaluate?.due_date)}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid container>

                                                    <Grid item lg={12} xs={12} display="flex" >
                                                        <Grid item xs={6} display="flex" flexDirection="column">
                                                            <Typography fontSize={14} lineHeight="24px" fontWeight={500} color="#AAAAAA">
                                                                {/* {dataEvaluate?.editor === "evaluator" ? */}
                                                                {t('evaluation.candidateProfile')}
                                                                {/* :
                                                                    t('evaluation.myProfile')
                                                                } */}
                                                            </Typography>
                                                            <Grid container display="flex" alignItems="flex-start" flexDirection="row">
                                                                <Grid
                                                                    item
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    mr={3}
                                                                >
                                                                    <Avatar
                                                                        src={dataEvaluate?.candidate?.photo}
                                                                        sx={{
                                                                            cursor: "pointer",
                                                                            width: 50,
                                                                            height: 50,
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs sm md lg>
                                                                    <Grid container mb="3px" display="flex" alignItems="center" justifyContent="space-between">
                                                                        <Grid item >
                                                                            <Typography fontSize={20} lineHeight="24px" fontWeight={600} color="primary">
                                                                                {formatData(dataEvaluate?.candidate?.fullname, "-")}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container>
                                                                        <Grid item xs sm md lg={12} display="flex" alignItems="center" >
                                                                            <Box display="flex" flexDirection="column" justifyContent="center">
                                                                                <Box display="flex" alignItems="center" pt="5px">
                                                                                    <BootstrapTooltip title={t(`label.position`)} placement="top">
                                                                                        <InnovationIcon style={{ cursor: "pointer", width: "20px", height: "20px" }}></InnovationIcon>
                                                                                    </BootstrapTooltip>
                                                                                    <Typography pl="10px" fontSize={18} lineHeight="26.91px" fontWeight={400} color="#404349">{Util.formatData(dataEvaluate?.candidate?.position, "-")} ({Util.formatData(datePosition, t('label.dateWork'))})</Typography>
                                                                                </Box>
                                                                                <Box display="flex" alignItems="center" pt="5px">
                                                                                    <BootstrapTooltip title={t(`label.team`)} placement="top">
                                                                                        <TeamIcon style={{ cursor: "pointer", width: "20px", height: "20px" }}></TeamIcon>
                                                                                    </BootstrapTooltip>
                                                                                    <Typography pl="10px" fontSize={18} lineHeight="26.91px" fontWeight={400} color="#404349">{formatData(dataEvaluate?.candidate?.organization, "-")}</Typography>
                                                                                </Box>
                                                                                <Box display="flex" alignItems="center" pt="5px">
                                                                                    <BootstrapTooltip title={t(`label.startDate`)} placement="top">
                                                                                        <DateIcon style={{ cursor: "pointer", width: "20px", height: "20px" }}></DateIcon>
                                                                                    </BootstrapTooltip>
                                                                                    <Typography pl="10px" fontSize={18} lineHeight="26.91px" fontWeight={400} color="#404349">{Util.dateDayFormatAdmin(dataEvaluate?.candidate?.employee_start_at, "-")} ({Util.formatData(dateEmpoloyee, t('label.dateWork'))})</Typography>
                                                                                </Box>
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Box sx={{ borderLeft: "1px solid #E5E5E5" }}></Box>
                                                        {/* <Grid item xs={6} display="flex"> */}
                                                        <Grid item xs={6} display="flex" flexDirection="column" pl="30px">
                                                            <Typography fontSize={14} lineHeight="24px" fontWeight={500} color="#AAAAAA">
                                                                {/* {dataEvaluate.editor_type === "superior" ? */}
                                                                {/* {t('evaluation.evaluationManage')} */}
                                                                {/* :
                                                                ('self', 'superior', 'subordinate', 'peer')
                                                                    t('evaluation.myEvaluator')
                                                                } */}
                                                                {dataEvaluate.editor_type === "self" ? t('evaluation.self')
                                                                    : dataEvaluate.editor_type === "superior" ? t('evaluation.superior')
                                                                        : dataEvaluate.editor_type === "subordinate" ? t('evaluation.subordinate')
                                                                            : dataEvaluate.editor_type === "peer" ? t('evaluation.peer')
                                                                                : ""
                                                                }
                                                            </Typography>
                                                            <Grid container display="flex" alignItems="flex-start" flexDirection="row">
                                                                <Grid
                                                                    item
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    mr={3}
                                                                >
                                                                    <Avatar
                                                                        src={dataEvaluate?.evaluator?.photo}
                                                                        sx={{
                                                                            cursor: "pointer",
                                                                            width: 50,
                                                                            height: 50,
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs sm md lg>
                                                                    <Grid container mb="3px">
                                                                        <Grid item>
                                                                            <Typography fontSize={20} lineHeight="24px" fontWeight={600} color="primary">
                                                                                {formatData(dataEvaluate?.evaluator?.fullname, "-")}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container>
                                                                        <Grid item xs sm md lg={12} display="flex" alignItems="center" >
                                                                            <Box display="flex" flexDirection="column" justifyContent="center">
                                                                                <Box display="flex" alignItems="center" pt="5px">
                                                                                    <BootstrapTooltip title={t(`label.position`)} placement="top">
                                                                                        <InnovationIcon style={{ cursor: "pointer", width: "20px", height: "20px" }}></InnovationIcon>
                                                                                    </BootstrapTooltip>
                                                                                    <Typography pl="10px" fontSize={18} lineHeight="26.91px" fontWeight={400} color="#404349" >{formatData(dataEvaluate?.evaluator?.position, "-")}</Typography>
                                                                                </Box>
                                                                                <Box display="flex" alignItems="center" pt="5px">
                                                                                    <BootstrapTooltip title={t(`label.team`)} placement="top">
                                                                                        <TeamIcon style={{ cursor: "pointer", width: "20px", height: "20px" }}></TeamIcon>
                                                                                    </BootstrapTooltip>
                                                                                    <Typography pl="10px" fontSize={18} lineHeight="26.91px" fontWeight={400} color="#404349" >{formatData(dataEvaluate?.evaluator?.organization, "-")}</Typography>
                                                                                </Box>
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        {/* </Grid> */}
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container pt="18px" sx={{ "flex-wrap": "nowrap !important" }}>
                                <Box width="50%" pr="16px" >
                                    <Card sx={{ height: 1, "box-shadow": "0px 0px 4px rgba(0, 0, 0, 0.1)", "border-radius": "5px" }} >
                                        {color.length > 0 ? <EvaluationRatio color={color} datas={dataEvaluate?.evaluate_summary?.evalutation_ratio} /> : null}
                                    </Card>
                                </Box>
                                <Box width="50%" pl="16px">
                                    <Card sx={{ height: 1, "box-shadow": "0px 0px 4px rgba(0, 0, 0, 0.1)", "border-radius": "5px" }}>
                                        <RatingSummary checkeNextAction={checkeNextAction} editor={dataEvaluate?.editor} datas={dataEvaluate?.evaluate_summary?.rating_summary} dataPercent={dataEvaluate?.evaluate_summary?.rating_summary_percent} config={dataEvaluate?.evaluate_template_config?.score_decimal} />
                                    </Card>
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sx={{ paddingTop: "30px !important" }}>
                            <Divider />
                        </Grid>
                        <Grid container item mb={hideEvaluation === true || dataEvaluate?.evaluate_step?.step.filter(item => item.type === "signoff" && item.is_current === true).length > 0 ? "30px" : "0px"} sx={{ pt: "0px!important" }}>
                            <Grid container >
                                <Grid item md={12} >
                                    {workloadFormSelect?.length > 0 ?
                                        <Grid container item mt={"30px"}>
                                            <Grid
                                                item
                                                display="flex"
                                                alignItems="center"
                                                flexDirection="row"
                                                justifyContent="space-between"
                                                width="100%"
                                            >
                                                <Box sx={{ display: "flex", "flex-direction": "row", "align-items": "center", cursor: "pointer" }} onClick={onHideEvaluationChange}>
                                                    <div
                                                        className={`${classes.iconContainer}`}
                                                        style={{ background: "#E388B9" }}
                                                    >
                                                        <img src={icon360} alt="bannerImage" />
                                                    </div>
                                                    <Typography variant="h2" pl="20px" fontSize={30} lineHeight="33px" color="#404349">
                                                        {t('label.evaluationForm360')}
                                                    </Typography>
                                                </Box>
                                                <Box height="24px">
                                                    {hideEvaluation === false ? <ChevronDown style={{ cursor: "pointer" }} onClick={onHideEvaluationChange} /> : <ChevronUp style={{ cursor: "pointer" }} onClick={onHideEvaluationChange} />}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        : null}
                                </Grid>
                            </Grid>
                            <Collapse in={dataEvaluate?.evaluate_step?.step.filter(item => item.type === "signoff" && item.is_current === true).length > 0 ? hideEvaluation : !hideEvaluation} sx={{ width: "100%" }}>
                                <Grid item lg={12} md={12} >
                                    {/* <Collapse in={hideEvaluation}> */}
                                    <Grid item md={12} mb="30px" sx={{ borderBottom: "1px solid #e4e4e4" }} pt="16px">
                                        <Grid container item alignItems="center">
                                            <Tabs
                                                value={value}
                                                indicatorColor="primary"
                                                textColor="primary"
                                                onChange={handleChange}
                                                aria-label="Tabs"
                                                variant="scrollable"
                                                scrollButtons
                                                allowScrollButtonsMobile
                                                TabIndicatorProps={{
                                                    style: {
                                                        height: "8px",
                                                        fontSize: "20px",
                                                    },
                                                }}
                                            >
                                                <Tab label={<span style={{ "font-size": "16px", display: "flex", color: actSave === false ? value === `overall` ? "#5DA196" : "#939393" : showTypeError['overall'] !== true ? value === "overall" ? "#5DA196" : "#939393" : "#CC6058" }}>{t('360Evaluation.label.overall')} <Box ml={2} px="4px" height="20px" minWidth="20px" sx={{ background: actSave === false ? value === `overall` ? "rgba(93, 161, 150, 0.15)" : "rgba(64, 67, 73, 0.15)" : showTypeError[`overall`] !== true ? value === `overall` ? "rgba(93, 161, 150, 0.15)" : "rgba(64, 67, 73, 0.15)" : "#F7E7E6", borderRadius: "2px" }}><Typography fontSize={18} lineHeight="20px" fontWeight="500" color={actSave === false ? value === `overall` ? "#5DA196" : "#939393" : showTypeError['overall'] !== true ? value === `overall` ? "#5DA196" : "#939393" : "#CC6058"}>{Util.formatData(Datas[0]?.total, 0)}</Typography></Box></span>} value={'overall'} classes={{ root: classes.tab }} />
                                                <Tab label={<span style={{ "font-size": "16px", display: "flex", color: actSave === false ? value === `comment` ? "#5DA196" : "#939393" : showTypeError['comment'] !== true ? value === "comment" ? "#5DA196" : "#939393" : "#CC6058" }}>{t('360Evaluation.label.comment')} </span>} value={'comment'} classes={{ root: classes.tab }} />
                                            </Tabs>
                                        </Grid>
                                    </Grid>
                                    {Datas !== undefined && Datas !== null && Datas.length > 0 ? Datas.map((loRow, index) => (
                                        <>
                                            {loRow?.type === "comment" ?
                                                <CommentTab instruction={instruction} checkeNextAction={checkeNextAction} loRow={loRow} value={value} statusEdit={statusEdit} callBack={callBack} editor={dataEvaluate?.editor} submitError={submitError} actSave={actSave} />
                                                :
                                                <Grid container sx={{ display: value === `overall` ? 'block' : 'none' }}>
                                                    <Grid item sm={12} xs={12} pb="30px" sx={{ display: "flex", "flex-flow": "row", "justify-content": "space-between" }}>
                                                        {loRow?.type === "goal" ?
                                                            <Box>
                                                                <Typography fontSize={24} fontWeight={500} lineHeight="35.88px" color="#404349" sx={{ "text-transform": "capitalize" }}>{t('evaluation.goalsEvaluation')}</Typography>
                                                                <Typography fontSize={16} fontWeight="fontWeightLight" variant="label" color="#9E9E9E" sx={{ "text-transform": "capitalize" }}>{t('evaluation.totalGoals')}: {loRow?.total} {t('evaluation.unitGoals')} </Typography>
                                                            </Box>
                                                            : loRow?.type === "custom" ?
                                                                <Box>
                                                                    <Typography fontSize={24} fontWeight={500} lineHeight="35.88px" color="#404349" sx={{ "text-transform": "capitalize" }} >{Util.formatData(loRow?.name, false) !== false ? loRow?.name : "Custom Form"}</Typography>
                                                                    <Typography fontSize={16} fontWeight="fontWeightLight" variant="label" color="#9E9E9E" sx={{ "text-transform": "capitalize" }}>{t('360Evaluation.label.total')} {Util.formatData(loRow?.name, false) !== false ? loRow?.name : "Custom Form"}{t('360Evaluation.label.totalTH')} : {loRow?.total} {t('evaluation.item')} </Typography>
                                                                </Box>
                                                                :
                                                                <Box>
                                                                    <Typography fontSize={24} fontWeight={500} lineHeight="35.88px" color="#404349" sx={{ "text-transform": "capitalize" }} >{t('evaluation.competencyEvaluation')}</Typography>
                                                                    <Typography fontSize={16} fontWeight="fontWeightLight" variant="label" color="#9E9E9E" sx={{ "text-transform": "capitalize" }}>{t('evaluation.totalCompetency')}: {loRow?.total} {t('evaluation.unitCompetencies')} </Typography>
                                                                </Box>
                                                        }
                                                    </Grid>
                                                    {Util.formatData(instruction, false) !== false ?
                                                        <Box pb="30px">
                                                            <Box sx={{ background: "#EFF6F4", border: "1px solid #5DA196", borderRadius: "5px", display: "flex", padding: "15px" }}>
                                                                <Megaphone></Megaphone>
                                                                <Typography fontSize={18} lineHeight="19.8px" color="#5DA196" pl="10px" dangerouslySetInnerHTML={{ __html: instruction }}>
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                        : null}
                                                    {Util.formatData(loRow?.list_item, false) !== false && loRow?.list_item.length > 0 ? loRow.list_item.map((rs, id) => (
                                                        <ListData have_feedback_competency={dataEvaluate?.have_feedback_competency} have_feedback_goal={dataEvaluate?.have_feedback_goal} dataEmpolyee={dataEvaluate?.candidate} dataEmpolyeeOwner={dataEvaluate?.evaluator} have_manager_evaluation={dataEvaluate?.have_manager_evaluation} have_self_evaluation={dataEvaluate?.have_self_evaluation} checkeNextAction={checkeNextAction} rs={rs} loRow={loRow} statusEdit={statusEdit} callBack={callBack} editor={dataEvaluate?.editor} submitError={submitError} actSave={actSave} formID={dataEvaluate?.form_evaluate_id} />
                                                    ))
                                                        :
                                                        <Grid item sx={styles.emty} >
                                                            <img src={emty} alt="emtyData"></img>
                                                            <Typography pt={1} fontSize={16} fontWeight="fontWeightLight" variant="label">
                                                                {loRow?.type === "goal" ?
                                                                    t('evaluation.emtyGoal')
                                                                    : loRow?.type === "competency" ?
                                                                        t('evaluation.emtyCompetency')
                                                                        : "Your evaluation has not been assigned yet."
                                                                }
                                                            </Typography>
                                                        </Grid>
                                                    }
                                                </Grid>
                                            }
                                        </>
                                    ))
                                        : null
                                    }
                                </Grid>
                            </Collapse>
                        </Grid>
                    </Grid>
                    {
                        dataEvaluate?.evaluate_step?.step.filter(item => item.type === "signoff" && item.is_current === true).length > 0 ?
                            <>
                                <Grid item>
                                    <Divider />
                                </Grid>
                                <Grid container item mt={"30px"} mb="30px">
                                    <Grid
                                        item
                                        md={6}
                                        display="flex"
                                        alignItems="center"
                                        flexDirection="row"
                                    >
                                        <Box sx={{ display: "flex", "flex-direction": "row", "align-items": "center", }}>
                                            <div
                                                className={`${classes.iconContainer}`}
                                                style={{ background: "#2A8A71" }}
                                            >
                                                <img src={signatures} alt="bannerImage" />
                                            </div>
                                            <Typography variant="h2" pl="20px" fontSize={30} lineHeight="33px" color="#404349">
                                                {t('evaluation.evaluationSignatures')}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid container item sx={{ display: "block" }}>
                                        <Box>
                                            <Typography pt="20px" pb="32px" fontSize="18px" lineHeight={1.1} fontWeight="400" color="#404349">
                                                {t('evaluation.subTilteEvaluationSignatures')}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ padding: "31px 0", background: "#FFFFFF", border: "1px solid #E4E4E4", "box-sizing": "border-box", borderRadius: "10px", display: "flex", "flex-direction": "row", justifyContent: "center" }}>
                                            <Box sx={{ "width": "calc(50% - 25px)", "max-width": "611px", "text-align": "center", margin: "0 25px" }} px="25px">
                                                <Typography fontSize="16px" lineHeight="24px" fontWeight="400" color="#A0A0A0" pb="5px">
                                                    {t('evaluation.evaluatorSignature')}
                                                </Typography>
                                                <Typography fontSize="20px" lineHeight="24px" fontWeight="500" color="#5DA196" pb="15px">
                                                    {formatData(dataEvaluate?.evaluator?.fullname, "-")}
                                                </Typography>
                                                <Typography fontSize="18px" lineHeight="19.8px" fontWeight="400" color="#404349" sx={{ "text-align": "center" }}>
                                                    {t('evaluation.agreeToContentEvaluator')}
                                                </Typography>
                                                <Box sx={{ "padding-top": statusEdit ? "20px" : "37px", "padding-bottom": statusEdit ? "10px" : "26px", '& div > input': { "text-align": "center", "font-size": "18px", "line-height": "26.91px", padding: "17px 14px", color: "#404349" } }}>
                                                    {dataEvaluate?.evaluate_step?.sign_off !== undefined && dataEvaluate?.evaluate_step?.sign_off !== null && dataEvaluate?.evaluate_step?.sign_off !== "" ?
                                                        dataEvaluate?.evaluate_step?.sign_off?.manager?.sign === true ?
                                                            <Typography fontSize="18px" lineHeight="26.91px" fontWeight="500" color="#404349" sx={{ textTransform: "uppercase" }}>
                                                                {dataEvaluate?.evaluate_step?.sign_off?.manager?.fullname}
                                                            </Typography>
                                                            :
                                                            <Typography fontSize="18px" lineHeight="26.91px" fontWeight="400" color="#C4C4C4">
                                                                {t('evaluation.notSignedYet')}
                                                            </Typography>
                                                        :
                                                        <Typography fontSize="18px" lineHeight="26.91px" fontWeight="400" color="#C4C4C4">
                                                            {t('evaluation.notSignedYet')}
                                                        </Typography>
                                                    }
                                                </Box>
                                                <Typography fontSize="18px" lineHeight="19.8px" fontWeight="400" color="#A0A0A0">
                                                    ({t('evaluation.signOffDate')}: {formatData(dateDayFormat(dataEvaluate?.evaluate_step?.sign_off?.manager?.updated_at), "-")})
                                                </Typography>
                                            </Box>
                                            <Box sx={{ "width": "calc(50% - 25px)", "max-width": "611px", "text-align": "center", margin: "0 25px" }} px="25px">
                                                <Typography fontSize="16px" lineHeight="24px" fontWeight="400" color="#A0A0A0" pb="5px">
                                                    {t('evaluation.candidateSignature')}
                                                </Typography>
                                                <Typography fontSize="20px" lineHeight="24px" fontWeight="500" color="#5DA196" pb="15px">
                                                    {formatData(dataEvaluate?.candidate?.fullname, "-")}
                                                </Typography>
                                                <Typography fontSize="18px" lineHeight="19.8px" fontWeight="400" color="#404349" sx={{ "text-align": "center" }}>
                                                    {t('evaluation.agreeToContentEmployee')}
                                                </Typography>
                                                <Box sx={{ "padding-top": statusEdit ? "20px" : "37px", "padding-bottom": statusEdit ? "10px" : "26px", '& div > input': { "text-align": "center", "font-size": "18px", "line-height": "26.91px", padding: "17px 14px", color: "#404349" } }}>
                                                    {dataEvaluate?.evaluate_step?.sign_off !== undefined && dataEvaluate?.evaluate_step?.sign_off !== null && dataEvaluate?.evaluate_step?.sign_off !== "" ?
                                                        dataEvaluate?.evaluate_step?.sign_off?.self?.sign === true ?
                                                            <Typography fontSize="18px" lineHeight="26.91px" fontWeight="500" color="#404349" sx={{ textTransform: "uppercase" }}>
                                                                {dataEvaluate?.evaluate_step?.sign_off?.self?.fullname}
                                                            </Typography>
                                                            :
                                                            <Typography fontSize="18px" lineHeight="26.91px" fontWeight="400" color="#C4C4C4">
                                                                {t('evaluation.notSignedYet')}
                                                            </Typography>
                                                        :
                                                        <Typography fontSize="18px" lineHeight="26.91px" fontWeight="400" color="#C4C4C4">
                                                            {t('evaluation.notSignedYet')}
                                                        </Typography>
                                                    }
                                                </Box>
                                                <Typography fontSize="18px" lineHeight="19.8px" fontWeight="400" color="#A0A0A0">
                                                    ({t('evaluation.signOffDate')}: {formatData(dateDayFormat(dataEvaluate?.evaluate_step?.sign_off?.self?.updated_at), "-")})
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </>
                            : null
                    }
                    {checkeNextAction?.options?.promote?.can_view === true && dataEvaluate?.promotion_note === true ?
                        <Grid container item sx={{ display: "block" }}>
                            <Box sx={{ padding: "33px 35px 39px", background: "#FFFFFF", border: "1px solid #E4E4E4", "box-sizing": "border-box", borderRadius: "10px", display: "flex", "flex-direction": "row" }}>
                                <Box width={40}>
                                    <Box onClick={onPromotionChange} sx={{ cursor: statusEdit ? checkeNextAction?.options?.promote?.can_edit !== true ? "default" : "pointer" : "default", background: isPromotionChecked ? checkeNextAction?.options?.promote?.can_edit === true ? "#5DA196" : "#5DA196" : "", border: "1px solid #DADADA", "box-sizing": "border-box", borderRadius: "3px", width: "25px", height: '25px', display: "flex", "flex-direction": "row", "justify-content": "center", "align-items": "center", }}>
                                        <Checks />
                                    </Box>
                                </Box>
                                <Box sx={{
                                    width: "100%",
                                    ".MuiFormHelperText-root": {
                                        color: " #CC6058 !important",
                                        fontSize: "14px",
                                        lineHeight: "15.4px",
                                        // marginLeft: 0,
                                        // position: "absolute",
                                        // bottom: "-22px",
                                    },
                                    ".MuiOutlinedInput-notchedOutline .Mui-error": {
                                        "border-color": isPromotionChecked && Util.formatData(employeeSignatures, false) === false && statusSend ? "#CC6058 !important" : ""
                                    }
                                }}>
                                    <Typography fontSize="18px" lineHeight="19.8px" fontWeight="400" color="#404349" pb="5px">
                                        {t('evaluation.promotionPreparation')}
                                    </Typography>
                                    <Typography fontSize="16px" lineHeight="17.6px" fontWeight="400" color="#939393" pb="25px">
                                        {t('evaluation.CheckReadyPpromoted')}
                                    </Typography>
                                    <Typography fontSize="18px" lineHeight="19.8px" fontWeight="400" color="#404349" pb="10px" sx={{ display: "inline-flex" }}>{t('evaluation.promote')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                    {statusEdit && checkeNextAction?.options?.promote?.can_edit === true ?
                                        <Box sx={{
                                            width: "100%", minWidth: "450px", '& div > input': {
                                                "font-size": "16px", "line-height": "17.6px", padding: "13.5px 14px", color: "#404349"
                                            }
                                        }}>
                                            <TextField
                                                fullWidth
                                                name="evaluator_comment"
                                                // placeholder='Enter your name'
                                                onChange={e => setEmployeeSignatures(e.target.value)}
                                                value={employeeSignatures}
                                                variant="outlined"
                                                helperText={isPromotionChecked && Util.formatData(employeeSignatures, false) === false && statusSend ? t('evaluation.pleaseSelectThisField') : ""}
                                                error={isPromotionChecked && Util.formatData(employeeSignatures, false) === false && statusSend}
                                                disabled={!isPromotionChecked || checkeNextAction?.options?.promote?.can_edit !== true ? true : false}
                                            />
                                        </Box>
                                        :
                                        <Box sx={{ border: "1px solid rgba(0, 0, 0, 0.26)", backgroundColor: "#fafafa", borderRadius: "4px", width: "100%", minWidth: "450px", minHeight: "50px" }}>
                                            <Typography fontSize="16px" lineHeight="17.6px" fontWeight="400" color="#404349" sx={{ "word-break": "break-all", padding: "13.5px 14px" }}>
                                                {employeeSignatures}
                                            </Typography>
                                        </Box>

                                    }
                                    <Typography fontSize="18px" lineHeight="19.8px" fontWeight="400" color="#404349" pt="25px" pb="10px">
                                        {t('evaluation.comment')}
                                    </Typography>
                                    {statusEdit && checkeNextAction?.options?.promote?.can_edit === true ?
                                        <Box sx={{
                                            width: "100%", minWidth: "450px", '& div > input': {
                                                "font-size": "16px", "line-height": "17.6px", padding: "13.5px 14px", color: "#404349"
                                            }
                                        }}>
                                            <TextField
                                                fullWidth
                                                name="comment"
                                                // placeholder='Enter your name'
                                                multiline
                                                minRows={3}
                                                onChange={e => setCommentPromotion(e.target.value)}
                                                value={commentPromotion}
                                                variant="outlined"
                                                disabled={!isPromotionChecked || checkeNextAction?.options?.promote?.can_edit !== true ? true : false}
                                            />
                                        </Box>
                                        :
                                        <Box sx={{ border: "1px solid rgba(0, 0, 0, 0.26)", backgroundColor: "#fafafa", borderRadius: "4px", width: "100%", minWidth: "450px", minHeight: "100px" }}>
                                            <Typography fontSize="16px" lineHeight="17.6px" fontWeight="400" color="#404349" sx={{ "word-break": "break-all", padding: "13.5px 14px" }}>
                                                {commentPromotion}
                                            </Typography>
                                        </Box>
                                    }
                                </Box>
                            </Box>
                        </Grid>
                        : null
                    }
                    <ConfirmDialog open={isConfirmCancelDialogOpen} warning={true} doConfirm={handleConfirmCancelList} setValue={handleConfirmCancelDialog} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
                    <SimpleDialog open={isSuccessSaveDialogOpen} setValue={closeSuccessSaveDialog} save={true} text={t('label.changesSuccessfully')} subTitle="" noClose={true} />
                    <ConfirmDialog open={discardDialog} warning={true} submit={true} twoText={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('evaluation.submitSignoff')} text={language === "en-US" ? t('evaluation.areYouSureSignoff') + '<br>' + dataEvaluate?.form?.name + '?' : "คุณแน่ใจหรือไม่ว่าต้องการ ลงนามรับทราบและส่งแบบประเมินผล" + dataEvaluate?.form?.name + " " + "ให้เสร็จสมบูรณ์?"} />
                    <Congrtulations open={isSuccessSignoffDialogOpen} setValue={handleSignoffDialog} name={dataEvaluate?.form?.name} editor={dataEvaluate?.editor} nameEmployee={dataEvaluate?.candidate?.fullname} formID={dataEvaluate?.form_evaluate_id} />
                    {/* <MessageDialog open={openFailedMessageDialog} setValue={handleCloseFailedMessageDialog} type="fail" title="ดำเนินการไม่สำเร็จ" text={errorText + " \nใหม่อีกครั้ง"} /> */}
                    <SimpleDialog open={isSuccessRejectDialogOpen} setValue={closeRejectSuccess} text="Reject successfully." subTitle="" noClose={true} />
                    <MoreInfo open={openMoreInfo} close={onCloseMoreInfo} formID={dataEvaluate?.form_evaluate_id} name={Util.formatData(dataEvaluate?.button?.button_moreinfo, t('label.moreInfo'))} />
                </Container >
            </Box >
            {Util.ScrollToTop()}
        </Box >
    )
};
export default Evaluation360;
